import { AppointmentDto } from "../calendar/interfaces/appointment_dto";

export function groupLessonsByStartTime(
    lessons: AppointmentDto[],
    ascending: boolean = true
  ) {
    const sections: {
      dateLabel: string;
      date: Date;
      lessons: AppointmentDto[];
    }[] = [];
    const currentDate = new Date();

    lessons.forEach((lesson) => {
      const date = new Date(lesson.StartTime);
      const dateLabel =
        date.toDateString() === currentDate.toDateString()
          ? "today"
          : date.toDateString();

      const section = sections.find((s) => s.dateLabel === dateLabel);

      if (section) {
        section.lessons.push(lesson);
      } else {
        sections.push({ dateLabel, date, lessons: [lesson] });
      }
    });

    if (ascending) {
      sections.sort((a, b) => a.date.getTime() - b.date.getTime());
      sections.forEach((section) => {
        section.lessons.sort(
          (a, b) =>
            new Date(a.StartTime).getTime() - new Date(b.StartTime).getTime()
        );
      });
    } else {
      sections.sort((a, b) => b.date.getTime() - a.date.getTime());
      sections.forEach((section) => {
        section.lessons.sort(
          (a, b) =>
            new Date(b.StartTime).getTime() - new Date(a.StartTime).getTime()
        );
      });
    }
    return sections;
  }